<!-- 出金异常数据日报 -->
<template>
  <div>
    <div class="opage">
      <!-- 资金/出金异常数据 -->
      <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.worldfirstCheckList')"></baseBreadcrumb>
      <div class="tab">
        <tableTab :val.sync="form.review_status" :list="[
          { name: '未复核', value: '0' },
          { name: '已复核', value: '1' },
          { name: '已终审', value: '2' },
        ]
          " :fun="getData">
        </tableTab>
        <!-- 操作 -->
        <div class="operation">

          <el-upload class="avatar-uploader" :action="baseURL + '/bill.wf.parseBill'" :show-file-list="false"
            :on-success="handleFileSuccess" :headers="{
              AdminToken: 'Bearer ' + token
            }" style="margin-right: 15px;">
            <el-button type="primary"> 账单上传导入</el-button>
          </el-upload>

          <el-button type="primary" class="primary" @click="thresholdDetail">异常核对阈值设置</el-button>
          <el-button type="primary" class="primary" v-if="form.review_status == 1"
            @click="batchFinalConfirm">批量终审</el-button>
          <el-button type="primary" class="primary" v-if="form.review_status == 0" @click="batchReview">批量复核</el-button>
        </div>
      </div>
      <!-- 搜索框 -->
      <div class="searchBox">
        <!-- 交易号 -->
        <el-input size="small" :placeholder="$t('message.transactionNumber')" v-model="form.purchase_no"
          clearable></el-input>
        <!-- WordFirst交易号 -->
        <el-input size="small" placeholder="WordFirst交易号" v-model="form.wf_transaction_no" clearable></el-input>
        <!-- 是否异常 -->
        <el-select size="small" placeholder="是否异常" v-model="form.is_abnormal" clearable>
          <el-option label="正常" value="0">
          </el-option>
          <el-option label="异常" value="1">
          </el-option>
        </el-select>
        <!-- 异常类型 -->
        <el-select size="small" v-model="form.abnormal_type" placeholder="异常类型" clearable>
          <el-option label="正常" value="0">
          </el-option>
          <el-option label="采购缺失" value="1">
          </el-option>
          <el-option label="金额异常" value="2">
          </el-option>
        </el-select>
        <!-- 动账类型 -->
        <el-select size="small" placeholder="动账类型" v-model="form.bill_type" clearable>
          <el-option label="支付" value="支付">
          </el-option>
          <el-option label="留空" value="留空">
          </el-option>
        </el-select>
        <!-- 最小金额 -->
        <el-input size="small" placeholder="最小金额" v-model="form.min_amount" clearable style="  flex: 0 0 120px;"
          type="number"></el-input>
        <!-- 最大金额 -->
        <el-input size="small" placeholder="最大金额" v-model="form.max_amount" clearable style="  flex: 0 0 120px;"
          type="number"></el-input>
        <!-- 部门名称 -->
        <!-- <el-input size="small" placeholder="部门名称" v-model="form.department_name" clearable></el-input> -->
        <!-- 日期范围 -->
        <el-date-picker v-model="time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" size="small"></el-date-picker>
        <div class="btns">
          <!-- 筛选 -->
          <el-button size="small" type="primary" @click="getData">{{
            $t("message.filter")
          }}</el-button>
          <!-- 重置 -->
          <!-- <el-button size="small" @click="chongZhi">{{
            $t("message.reset")
                        }}</el-button> -->
        </div>
      </div>
      <!-- 统计 -->
      <div class="total">
        统计:
        <span>出账金额:{{ totalKin.wf_amount_out_total }}元 </span>
        <span>异常金额:{{ totalKin.abnormal_amount_total }}元</span>
      </div>
      <div style="padding: 0 20px">
        <el-table :data="tableData" :header-cell-style="{ 'text-align': 'center', background: '#EDEFF4' }" :cell-style="{
          'text-align': 'center',
          background: '#f8f8f8',
        }" size="mini" @selection-change="handleSelectionChange" :max-height="tableautoheight">
          <el-table-column property="rowNumber" width="50" label="No"></el-table-column>

          <!-- 交易号创建时间 -->
          <el-table-column property="transaction_date" label="交易日期" width="82"></el-table-column>
          <!-- WF交易号 -->
          <el-table-column property="transaction_no" label="WF交易号" width="120"></el-table-column>
          <!--F交易号 -->
          <el-table-column property="merchant_order_no" label="交易号" width="150"></el-table-column>
          <!-- 收款名称 -->
          <el-table-column property="payee_name" label="收款名称"></el-table-column>
          <!-- WF出金金额 -->
          <el-table-column property="wf_amount_out" label="WF出金金额"></el-table-column>
          <!-- 系统采购金额  -->
          <el-table-column property="system_purchase_amount" label="系统采购金额"></el-table-column>
          <!-- 客户支付金额 -->
          <el-table-column property="client_amount" label="客户支付金额"></el-table-column>
          <!-- 异常金额 -->
          <el-table-column property="diff_amount" label="异常金额">
          </el-table-column>
          <!-- 异常类型 -->
          <el-table-column property="abnormal_type_name" label="异常类型"></el-table-column>
          <!-- 动账类型 -->
          <el-table-column property="bill_type" label="动账类型"></el-table-column>
          <!-- 财务备注 -->
          <el-table-column label="财务备注" width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.finance_remark" type="textarea" disabled>
              </el-input>
            </template>
          </el-table-column>
          <!-- 财务审核备注 -->
          <!-- <el-table-column property="review_remark" label="财务审核备注" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.review_remark"type="textarea"
               disabled>
              </el-input>
            </template>
          </el-table-column> -->
          <!-- 复核备注 -->
          <el-table-column type="selection" width="45" align="center">
          </el-table-column>
          <el-table-column property="review_remark" label="复核备注" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.review_remark" placeholder="请输入复核备注" type="textarea"
                @blur="worldfirstCheckUpdateAuditRemark(scope.row)">
              </el-input>
            </template>
          </el-table-column>
          <!-- 订单号 -->
          <el-table-column property="order_sn" label="订单号" width="170">
            <template slot-scope="scope">
              <span v-if="scope.row.order_sn">{{ scope.row.order_sn }}</span>
              <el-button v-else size="mini" type="primary" @click="manualMatch(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
          <!-- 是否异常 -->
          <el-table-column label="是否异常">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.is_abnormal == 0 ? 'success' : 'danger'">
                {{ scope.row.is_abnormal == 0 ? '正常' : '异常' }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- 复核人 -->
          <el-table-column property="review_realname" label="复核人"></el-table-column>
          <!-- 终审人 -->
          <!-- <el-table-column property="final_realname" label="终审人"></el-table-column> -->
          <!--操作 -->
          <el-table-column :label="$t('message.operation')">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" v-if="scope.row.review_status == '0'"
                @click="worldfirstCheckReview([scope.row.id])">复核</el-button>
              <el-button size="mini" type="primary" v-else-if="scope.row.review_status == '1'"
                @click="worldfirstCheckFinalConfirm([scope.row.id])">终审</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[30, 50, 100, 200, 300]" :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
      <!-- 异常核对阈值设置弹框 -->
      <el-dialog title="异常核对阈值设置" :visible.sync="dialogVisible" width="480px" :close-on-click-modal="false" center>
        <div class="thresholdDetailData">
          <span> {{ thresholdDetailData.name }}：</span> <el-input v-model="thresholdDetailData.value" placeholder="阈值金额"
            type="number"></el-input>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="thresholdSave">{{ $t('message.save') }}</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import myImage from "@/components/uploadFile/uploadFile.vue";
import tableTab from "../components/tableTab.vue";
export default {
  data() {
    return {
      token: localStorage.getItem('japan_access_token'),
      tableautoheight: window.innerHeight > 700 ? window.innerHeight - 240 : 800,
      form: {
        page: 1,
        pageSize: 30,
        review_status: '0',
      },
      time: [],
      totalKin: {
        wf_amount_out_total: 0,
        abnormal_amount_total: 0,
      },
      total: 0,
      loading: null,
      tableData: [],
      selectedRows: [],
      dialogVisible: false, // 淘宝支付弹框是否显示
      thresholdDetailData: {}//异常核对阈值-详情
    };
  },
  components: {
    myImage,
    tableTab,
  },
  computed: {
  },
  mounted() {
    this.getData();

  },
  methods: {
    // 获取数据
    getData() {
      if (this.time != false) {
        this.form.start_time = this.time[0]
        this.form.end_time = this.time[1]
      } else {
        this.form.start_time = ''
        this.form.end_time = ''
      }
      this.$api.financialApi
        .worldfirstCheckList(this.form)
        .then((res) => {
          // console.log("事件名", res.data.data);
          if (res.code != 0) return this.$message.error(res.msg);
          // 接下来的操作
          this.tableData = res.data.data;
          this.total = res.data.total
          this.$forceUpdate();
        });
      // 获取统计
      this.worldfirstCheckStat();
    },
    // 获取统计
    worldfirstCheckStat() {
      this.$api.financialApi
        .worldfirstCheckStat(this.form)
        .then((res) => {

          this.totalKin = res.data;
          this.$forceUpdate();
        });
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getData();
    },
    // 处理选择变化
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    // 更新复核备注
    worldfirstCheckUpdateAuditRemark(row) {
      this.$api.financialApi
        .worldfirstCheckUpdateAuditRemark({
          ids: [row.id],
          review_remark: row.review_remark,
        })
        .then((res) => {

          this.$message.success(res.msg);

        })
        .catch(() => { });
    },
    // 手动添加订单号
    manualMatch(row) {
      this.$prompt('请输入订单号', '编辑订单号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.order_sn || '',
        inputValidator: (value) => {
          if (!value || !value.trim()) return '请输入订单号';
          return true;
        },
      })
        .then(({ value }) => {
          const order_sn = value.trim();
          this.$api.financialApi
            .manualMatch({
              ids: [row.id],
              order_sn,
            })
            .then((res) => {
              if (res.code != 0) return this.$message.error(res.msg);
              this.$message.success(res.msg);
              this.getData();
            })
            .catch(() => { });
        })
        .catch(() => { });
    },
    // 异常核对阈值-详情
    thresholdDetail() {
      this.$api.financialApi
        .worldfirstCheckFinalConfirmDetail({
          ids: this.selectedRows.map(item => item.id)
        })
        .then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.thresholdDetailData = res.data;
          this.dialogVisible = true;
        })
        .catch(() => { });
    },
    // 异常核对阈值-保存
    thresholdSave() {
      if (!this.thresholdDetailData.value) return this.$message.error("请输入阈值金额");
      this.$api.financialApi
        .worldfirstCheckThresholdSave({
          value: this.thresholdDetailData.value,
        })
        .then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);

          this.dialogVisible = false
        });
    },
    // 确认复核
    worldfirstCheckReview(ids) {
      let datas = {
        ids: ids
      }
      this.$confirm(
        '是否确认复核？',
        '提示',
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.financialApi
            .worldfirstCheckReview(datas)
            .then((res) => {
              if (res.code != 0) return this.$message.error(res.msg);
              this.$message.success(res.msg);
              this.getData();
              this.selectedRows = [];
            })
            .catch(() => { });
        })
        .catch(() => { });
    },
    // 批量确认复核
    batchReview() {
      if (this.selectedRows.length == 0) return this.$message.error("请选择要确认复核的记录");
      this.worldfirstCheckReview(this.selectedRows.map(item => item.id));
    },
    // 批量确认终审
    batchFinalConfirm() {
      if (this.selectedRows.length == 0) return this.$message.error("请选择要确认终审的记录");
      this.worldfirstCheckFinalConfirm(this.selectedRows.map(item => item.id));
    },
    // 确认终审
    worldfirstCheckFinalConfirm(ids) {
      let datas = {
        ids: ids
      }
      this.$confirm(
        '是否确认终审？',
        '提示',
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.financialApi
            .worldfirstCheckFinalConfirm(datas)
            .then((res) => {
              if (res.code != 0) return this.$message.error(res.msg);
              this.$message.success(res.msg);
              this.getData();
              this.selectedRows = [];
            })
            .catch(() => { });
        })
        .catch(() => { });
    },
    // 上传文件成功后的回调
    handleFileSuccess(res, file) {
      if (res.code == 0) {
        this.$message({
          message: '上传成功',
          type: 'success',
        })
        this.getData();
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
        })
      }
      console.log(res, file)
    },

  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

.routerView {
  height: 100%;
}

.opage {
  background-color: #f8f8f8;
  height: 100%
}

.tab {
  position: relative;

  .operation {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
  }
}

.total {
  font-size: 16px;
  color: #333333;
  margin: 20px 24px;

  span {
    margin-left: 30px;

    &:nth-last-child(1) {
      color: #fa5058;
    }
  }
}

.searchBox {
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 15px;

  >* {
    flex: 0 0 160px;
    margin-right: 10px;
  }

  .el-date-editor {
    flex: 0 0 350px;
  }

  .btns {
    flex: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 0;

    .el-button {
      width: 64px;
      margin-left: 15px;
    }
  }
}

/deep/.tableMy {
  th {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .keHu {
    p {
      text-align: center;
    }
  }

  .dingDanZhiFuRuJin {
    p {
      text-align: left;
    }
  }

  .lianXiFangShi {
    color: #2c96e7;
    cursor: pointer;
  }

  .link {
    color: #fa5058;
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-button {
      display: flex;
      margin: 0 0 8px 0;
    }
  }
}



.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}

/deep/.el-textarea__inner {
  padding: 5px !important;
  height: 100px !important;
  resize: none;
}

.bgcRed {
  background-color: #fa5058 !important;
  color: #fff !important;
}

.bgcYellow {
  background-color: #f5a623 !important;
  color: #fff !important;
}

.bgcBlue {
  background-color: #2c96e7 !important;
  color: #fff !important;
}

.thresholdDetailData {
  padding: 20px;
  line-height: 40px;
  display: flex;

  span {
    width: 280px;
  }
}
</style>
